<div class="modal-container">
    <!-- Cabeçalho do Modal -->
    <div class="modal-header">
        <h5 class="modal-title">
            📂 Nome do Arquivo: <strong> {{ fileSelected.fileName }} </strong>
        </h5>
    </div>

    <!-- Corpo do Modal -->
    <div class="modal-body">
        <!-- Resumo do Arquivo -->
        <div class="file-summary p-3 border rounded">
            <p><strong>📑 Número do Arquivo:</strong> {{ fileSelected.fileNumber }}</p>
            <p><strong>📅 Data Gerada:</strong> {{ fileSelected.generatedDate | date: 'dd/MM/yyyy' }}</p>
            <p><strong>👤 Usuário:</strong> {{ fileSelected.userName }}</p>
            <p><strong>📋 Quantidade de Itens:</strong> {{ fileSelected?.items?.length }}</p>
        </div>

        <hr />

        <!-- Acordeão para Listar os Itens -->
        <h6 class="text-center">📜 Itens do Arquivo</h6>
        <ngb-accordion #acc="ngbAccordion" activeIds="item-0">
            <ngb-panel *ngFor="let item of fileSelected.items; let i = index" id="item-{{ i }}">
                <ng-template ngbPanelTitle>
                    <strong>Item {{ i + 1 }} - {{ item.statusSendIdDescription }}</strong>
                </ng-template>
                <ng-template ngbPanelContent>
                    <p><strong>🔢 Número:</strong> {{ item.billetNumber }}</p>
                    <p><strong>💰 Valor:</strong> R$ {{ item.billetValue | number: '1.2-2' }}</p>
                    <p><strong>💵 Desconto:</strong> R$ {{ item.discountValue | number: '1.2-2' }}</p>
                    <p><strong>📅 Vencimento:</strong> {{ item.billetDueDate | date: 'dd/MM/yyyy' }}</p>
                </ng-template>
            </ngb-panel>
        </ngb-accordion>
    </div>

    <!-- Rodapé do Modal -->
    <div class="modal-footer">
        <button class="btn btn-danger" (click)="closeModal()">Fechar</button>
    </div>
</div>
